import React, { useState, useEffect, useContext } from 'react';
import {format, getHours, subDays} from "date-fns";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import * as net from "../../lib/net";
import * as utils from "../../assets/utils";
import Dt_Cal from "../../lib/ui/dt_cal";
import Dd_Sel from "../../lib/ui/dd_sel";
import * as q from "../../lib/defer";

import PdfDlg from "../../lib/pdf/pdf_dlg";
import Slot_Gen from "./fkn/slot_gen";
import Slot_Add from "./fkn/slot_add";
import Slot_Edit from "./fkn/slot_edit";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Op_Slots extends React.Component {
  constructor(props, context) {
    super(props);

      this.dt_dt = React.createRef();
    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.typ = "01";
    this.state.datum = "20201231";

      this.state.today = new Date();
      var hh = getHours(this.state.today);
      if( hh < 5) {
          const dt = subDays(new Date(), 1);
          this.state.dts = format(dt, "yyyy-MM-dd");
      }
      else this.state.dts = format(this.state.today, "yyyy-MM-dd");

    this.state.sla = [];
    this.state.rda = [];
    this.state.aa = [];
    this.state.kta = [];
    this.state.pdf = 0;
    this.state.pdf_content = null;
    this.state.loading = 0;
    this.state.wnds = {};
    this.state.slo = {};

    this.state.loading = 0;
    this.state.urval = 1;
    this.state.uaa = [
        {id: '1', text: 'MED SALDO'},
        {id: '0', text: 'ALLA'}
    ];
    this.state.fknitems = [
        {fkn: 'day_add', text: 'LÄGG TILL DAG'},
        {fkn: 'day_clear', text: 'RENSA DAG'},
        {fkn: 'refresh', text: 'UPPDATERA'}
    ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    var self = this;
    self.slot_list();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 250;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
    dt_dat(e) {
        var self = this;
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ dts: dts }, function() {
            self.slot_list();
        });
    }
    addday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_dt.current.updateAdd();
    }
    subday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_dt.current.updateSub();
    }

  fltr(aa) {
      var self = this;
      //self.setState({loading: 0 });
      //var aa = self.state.rga;
      var a = [];
      for(var row of aa) {
          if(this.state.urval == 1) {
              var saldo = (row.vip02.v2tillgodo * 1);
              if(saldo == 0) continue;
              var text = (row.vip00.v0company);
              //if(text.indexOf("A") < 0) continue;
          }
          a.push( row );
      }
      return a;
    //self.setState({rda: a, loading: 0 });
  }

  ladda() {
    var self = this;
    var wnds = {};
    wnds.vipladda = 1;
    self.setState({ wnds: wnds });
  }
    slot_gen() {
        var self = this;
        var wnds = {};
        wnds.slotgen = 1;
        wnds.dts = this.state.dts;
        wnds.cb = self.cb_slots;
        self.setState({ wnds: wnds });
    }
    slot_add() {
        var self = this;
        var wnds = {};
        wnds.slotadd = 1;
        wnds.dts = this.state.dts;
        wnds.cb = self.cb_slots;
        self.setState({ wnds: wnds });
    }
    slot_edit(slo) {
        var self = this;
        var wnds = {};
        wnds.slotedit = 1;
        wnds.slo = slo;
        wnds.cb = self.cb_slots;
        self.setState({ wnds: wnds });
    }

    cb_slots(ctx, rsp) {
      ctx.slot_list();
        ctx.setState({ wnds: {} });
    }

    ladda_do() {
        var self = this;
    var prm = {};
    prm.req = "vcm.pres.refill";
    prm.typ = this.state.typ;
    prm.id = "12";
    prm.belopp = "4500";

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        alert(JSON.stringify(ret));
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  slot_list() {
    var self = this;
    self.setState({sla: [], loading: 1 });

    var prm = {};
    prm.req = "pos.pos_ecom_slot.slot_dt_list";
    prm.dts = this.state.dts;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        //var a = self.fltr(ret.rca);
        self.setState({sla: ret.rca, loading: 0 });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    slot_clear() {
        var self = this;
        self.setState({sla: [], loading: 1 });

        var prm = {};
        prm.req = "pos.pos_ecom_slot.slot_dt_clear";
        prm.dts = this.state.dts;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rca));

            //var a = self.fltr(ret.rca);
            self.setState({sla: [], loading: 0 });
            //toastr.success("OK", "SAPI");
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
  kts() {
    var self = this;
    var defer = q.defer();

    var prm = {};
    prm.req = "vip.vip_reg.kt_list";
    prm.typ = "";

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        var kta = [];
        for(var row of ret.rca) {
            var o = {};
            o.id = row.vip00.v0ktyp;
            o.text = row.vip00.v0company;
            kta.push( o );
        }
        //alert(JSON.stringify(kta));
        self.setState({kta: kta }, function() {
            var rsp = {};
            rsp.ok = "000";
            defer.resolve(rsp);
        });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        var rsp = {};
        rsp.ok = "999";
        defer.resolve(rsp);
    });

    return defer.promise;
  }
  prn_saldo() {
    var self = this;
    var prm = {};

    prm.req = "vip.vip_reg.reg_list";
    prm.typ = this.state.typ;
    prm.datum = this.state.datum;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        //self.setState({rga: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  prn_fkn(fkn) {
    var self = this;
    var prm = {};
    prm.req = fkn;
    prm.typ = this.state.typ;
    prm.viptyp = this.state.typ;
    prm.datum = "20201231";

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({pdf: 1, pdf_content: ret.pdf });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  pdf_done (ret) {
    this.setState({loading: 0, pdf: 0, pdf_content: null });
  }
    sel_fkn(sel) {
        //alert(JSON.stringify(fkn));
        if(sel.fkn == "day_add") {
            this.slot_gen();
        }
        if(sel.fkn == "day_clear") {
            this.slot_clear();
        }
        if(sel.fkn == "refresh") {
            this.slot_list();
        }
    }
    sel_typ (e) {
      var self = this;
      var typ = e.target.value;
      this.setState({typ: typ}, function() {
            self.reg_list();
        });
    }
    sel_urval (e) {
      var self = this;
      self.setState({loading: 1 });
      var urval = e.target.value;
      this.setState({urval: urval}, function() {
          var a = self.fltr(self.state.rga);
        self.setState({rda: a, loading: 0 });
      });
    }

  render() {
    return (
    <div className="web-p00 flex flex-col">
        <div className="">
            SLOTTAR
        </div>
    <div className="divider_orange"></div>

    <div className="flex-row">
        <div className="flex-row">
            <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
            <Dt_Cal dts={this.state.dts} rp="1" ref={this.dt_dt} getValue={(e)=> this.dt_dat(e)} />
            <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
        </div>

        <div className="flex"></div>

        <button className="btn btn-hw-blue w150" onClick={() => this.slot_gen() } aria-label="System" >
            SKAPA DAG
        </button>
        <button className="btn btn-hw-blue w150" onClick={() => this.slot_add() } aria-label="System" >
            NY SLOT
        </button>
        <button className="btn btn-hw-blue w150" onClick={() => this.slot_list() } aria-label="System" >
            VISA
        </button>
        <div className="">
            <Dd_Sel items={ this.state.fknitems } getValue={(e)=> this.sel_fkn(e)} />
        </div>
    </div>
    <div className="divider_green"></div>

    { this.state.loading ?
        <div className="mx_content flex align-items-center justify-content-center"><FontAwesomeIcon icon="spinner" spin size="3x"  /></div>
    :
    <div className="web-row">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
				<th>Datum</th>
				<th>Slottid</th>
                <th>Slotslut</th>
				<th>Text</th>
                <th>Antal</th>
                <th>Max Antal</th>
				<th>Slottyp</th>
                <th>Status</th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.sla.map((slo, key) =>
            <tr key={key} onDoubleClick={ () => this.slot_edit(slo) }>
                <td>{ utils.toDate( slo.datum ) }</td>
                <td>{ utils.toTid( slo.slottid ) }</td>
                <td>{ utils.toTid( slo.slotslut ) }</td>
                <td>{ slo.text }</td>
                <td>{ slo.order }</td>
                <td>{ slo.maxorder }</td>
                <td>{ slo.slottyp }</td>
                <td>{ slo.status }</td>
            </tr>
            )}
            </tbody>
        </table>
    </div>
    }

        <PdfDlg show={this.state.pdf} pdf={this.state.pdf_content} done={(ret) => this.pdf_done(ret)} backdrop={true}/>
        { this.state.wnds.slotgen ?
            <Slot_Gen wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/>
            : null }
        { this.state.wnds.slotadd ?
            <Slot_Add wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/>
            : null }
        { this.state.wnds.slotedit ?
            <Slot_Edit wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/>
            : null }
    </div>
  );
    }
}
export default Op_Slots;
